import { tokens } from './SEOPageLayout';

export interface SeoLongformSection {
  title: string;
  paragraphs: string[];
  bullets?: string[];
}

export interface SeoFaqItem {
  question: string;
  answer: string;
}

interface SeoLongformSectionsProps {
  sections: SeoLongformSection[];
  faqs: SeoFaqItem[];
}

export function SeoLongformSections({ sections, faqs }: SeoLongformSectionsProps) {
  return (
    <section className={tokens.sectionAlt}>
      <div className={tokens.container}>
        <div className="max-w-3xl mx-auto space-y-10">
          {sections.map((section) => (
            <div key={section.title}>
              <h2 className={`${tokens.heading.h2} mb-4`}>{section.title}</h2>
              <div className="space-y-4">
                {section.paragraphs.map((paragraph, index) => (
                  <p key={`${section.title}-p-${index}`} className={tokens.text.base}>
                    {paragraph}
                  </p>
                ))}
              </div>
              {section.bullets && section.bullets.length > 0 && (
                <ul className="mt-4 space-y-2 text-sm text-slate-300">
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>• {bullet}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          <div>
            <h2 className={`${tokens.heading.h2} mb-4`}>FAQ</h2>
            <div className="space-y-4">
              {faqs.map((faq) => (
                <div key={faq.question} className={tokens.card}>
                  <h3 className="text-white font-semibold mb-2">{faq.question}</h3>
                  <p className="text-sm text-slate-300">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
